import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'stock-location',
		pluralName: 'stock-locations',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
